module.exports = __webpack_public_path__ + "img/pay-room.e684c521.svg";